import React from 'react';
import SummaryCard from './SummaryCard';

function ImplementationTips({ tips, documents }) {
    return (
        <SummaryCard title="Implementation Tips">
            <div className="flex items-center gap-2 mb-6">
                <span className="text-red-500 text-lg">🎯</span>
                <span className="content-text font-medium text-gray-900">Implementation Tips</span>
            </div>

            {/* Tips List */}
            <div className="space-y-6 mb-8">
                {tips?.map((tip, idx) => (
                    <div key={tip.title || idx} className="flex gap-3">
                        <span className="content-text font-bold text-gray-900 flex-shrink-0">
                            {idx + 1}.
                        </span>
                        <div className="flex-1">
                            <h4 className="content-text font-medium text-gray-900 mb-2">
                                {tip.title}
                            </h4>
                            <p className="content-text text-gray-600 leading-relaxed">
                                {tip.desc}
                            </p>
                        </div>
                    </div>
                ))}
            </div>

            {/* Documents Section */}
            <div className="bg-purple-50 border border-purple-100 rounded-lg p-4">
                <h4 className="content-text font-medium text-gray-900 mb-4">
                    Documents You'll Need
                </h4>

                <div className="space-y-3">
                    {documents?.map((doc, idx) => (
                        <div key={doc} className="flex items-center gap-3">
                            <div className="w-5 h-5 rounded-full border-2 border-purple-400 flex items-center justify-center flex-shrink-0">
                                <div className="w-2 h-2 rounded-full bg-purple-400"></div>
                            </div>
                            <span className="content-text text-gray-700">
                                {doc}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        </SummaryCard>
    );
}

export default ImplementationTips;